const Cargos = [
  "Administração",
  "Analista",
  "CEO",
  "Coordenador ou supervisor",
  "Gerente",
  "Presidente",
];

export default Cargos;
